var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "64", height: "64", viewBox: "0 0 64 64", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M25.6 49.6L38.4 40.8L46.4 64L25.6 49.6Z", fill: "#0B955D" }),
    React.createElement("path", { d: "M-1.14441e-05 0L52.8 32L46.4 64L38.4 40.8L-1.14441e-05 0Z", fill: "#14C17B" }),
    React.createElement("path", { d: "M-.00000762939 0L38.4 40.8 18.1229 57.6976C16.4111 59.124 13.7966 58.2525 13.2831 56.0843L-.00000762939 0zM59.3445 19.287L0 0 52.8 32 60.5386 24.2614C62.1225 22.6775 61.4749 19.9793 59.3445 19.287z", fill: "#66D7AD" })
  );
});